import { Controller } from '@hotwired/stimulus'
import { t } from '@lingui/core/macro'

export default class MarketplaceBillingController extends Controller {
  static targets = ['entitlementSelect', 'dimensionsContainer']
  static values = { entitlements: Array }

  selectEntitlement() {
    const selectedId = this.entitlementSelectTarget.value
    const entitlement = this.entitlementsValue.find((e) => e.id === selectedId)

    this.dimensionsContainerTarget.innerHTML = ''

    if (!entitlement) return
    const id = document.createElement('input')
    id.setAttribute('type', 'hidden')
    id.setAttribute('name', 'agreement_id')
    id.setAttribute('value', entitlement.id)
    this.dimensionsContainerTarget.appendChild(id)

    const wrapper = document.createElement('div')
    wrapper.className = 'mb-3 row'
    wrapper.innerHTML = `
      <label class="col-sm-3 col-form-label" for='amount'>${t`Total Amount`}</label>
      <div class="col-sm-9">
        <input type="number"
               name="aws_marketplace_billing[amount]"
               aria-label="${t`Amount`}"
               class="form-control"
               min="0"
               placeholder="0"
               value="0">
      </div>`
    this.dimensionsContainerTarget.appendChild(wrapper)

    entitlement.pricing_dimensions.forEach((dimension) => {
      const wrapper = document.createElement('div')
      wrapper.className = 'mb-3 row'
      wrapper.innerHTML = `
        <label class="col-sm-3 col-form-label">${dimension.description}</label>
        <div class="col-sm-9">
          <input type="number"
                 name="aws_marketplace_billing[dimension][${dimension.id}]"
                 aria-label="${dimension.id}"
                 class="form-control"
                 min="0"
                 placeholder="0"
                 value="0">
        </div>
      `
      this.dimensionsContainerTarget.appendChild(wrapper)
    })
  }
}
